<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 0C4.04 0 0 4.04 0 9C0 13.96 4.04 18 9 18C13.96 18 18 13.96 18 9C18 4.04 13.96 0 9 0ZM16 9C16 10.57 15.47 12.02 14.6 13.18L4.82 3.4C5.98 2.53 7.43 2 9 2C12.86 2 16 5.14 16 9ZM2 9C2 7.43 2.53 5.98 3.4 4.82L13.18 14.6C12.02 15.47 10.57 16 9 16C5.14 16 2 12.86 2 9Z" fill="#7B61FF"/>
</svg>
